// To be able to request the Staging API from Local to increase development efficiency
export const STAGING_API_ENDPOINT = 'https://api.staging.up-sider.com:8081/bank'
